module.exports = __webpack_public_path__ + "assets/img/bc76093f179702fd52917092ce34ab6b.webp";